import { GetUserData, showToastMessage } from "common/service/CommonService";
import Reason from "common/utilities/Reason/Reason";
import { useCRFService } from "modules/Library/CRF/api/useCRFQuery";
import React, { useState } from "react";
import { useNavigate, NavigateFunction, useParams } from "react-router-dom";
import { LIBRARY_PATHS } from "Routes/paths";
import SurveyBuilder from "modules/Library/CRF/components/SurveyBuilder";
import { queryClient } from "api/queryClient";
import { CRFData, CRFItem, SurveyJSON } from "../helpers/crf.types";

const CRFEdit: React.FC = () => {
  document.title = "Edit CRF | ZENTIXS VISTA"
  const { id } = useParams<{ id: string }>();
  // Query client
  // Navigation
  const navigate: NavigateFunction = useNavigate();
  // CRF Service(s)
  const crfid = Number(id);
  const { SelectQuery, UpdateMutation } = useCRFService({
    id: crfid,
  });

  //-------------------------------------------------------------------------------------------
  //--> First data load
  //-------------------------------------------------------------------------------------------

  const {
    data: queryData,
    isLoading,
    isError,
  } = SelectQuery as {
    data?: { data?: CRFData[] };
    isLoading: boolean;
    isError: boolean;
  };

  const data: CRFItem[] = (queryData?.data ?? []).map((d) => ({
    id: d.id as number,
    ...d,
  }));

  //-------------------------------------------------------------------------------------------
  //--> Use State
  //-------------------------------------------------------------------------------------------

  const [updatedRecord, setUpdatedRecord] = useState<SurveyJSON | null>(null);
  //Reason Modal
  const [isReasonModal, setIsReasonModal] = useState<boolean>(false);

  //-------------------------------------------------------------------------------------------
  //--> Toggle
  //-------------------------------------------------------------------------------------------

  const toggleReasonModal = (): void => {
    setIsReasonModal((prev) => !prev);
  };

  //-------------------------------------------------------------------------------------------
  //--> Record Update
  //-------------------------------------------------------------------------------------------

  const btnReasonClick = (reasonPayload: {
    id: number | null;
    reason: string;
  }) => {
    if (!updatedRecord) return;
    if (!updatedRecord.title) {
      showToastMessage("error", "Please enter survey title!");
      return;
    }

    const payload: Partial<CRFData> & { updatereason: string } = {
      crfid: reasonPayload.id,
      name: updatedRecord.title as string,
      json: updatedRecord,
      updatereason: reasonPayload.reason,

    };

    UpdateMutation.mutate(payload, {
      onSuccess: (response) => {
        showToastMessage("success", response?.message);
        toggleReasonModal();
        navigate(LIBRARY_PATHS.CRF_LIST);
        queryClient.invalidateQueries({ queryKey: ["crf-selectAll"] });
        queryClient.invalidateQueries({ queryKey: ["crf-select", crfid] });
        setUpdatedRecord(null);
      },
      onError: (error) => {
        showToastMessage("error", error?.message ?? error);
      },
    });
  };

  //-------------------------------------------------------------------------------------------
  //--> Record Update
  //-------------------------------------------------------------------------------------------

  const saveCRF = (updatedCRF: any): void => {
    setUpdatedRecord(updatedCRF.json);
    toggleReasonModal();
  };

  // if (!data) return <p>Loading...</p>;

  return (
    <>
      <SurveyBuilder
        initialJSON={data[0]}
        onSave={saveCRF}
        isLoading={isLoading}
      />

      {/* Reason Modal */}
      {isReasonModal && (
        <Reason
          isOpen={isReasonModal}
          toggle={toggleReasonModal}
          action="Update"
          id={Number(data[0]?.crfid) ?? 0}
          click={btnReasonClick}
          isLoading={!!UpdateMutation.isPending}
        />
      )}
    </>
  );
};

export default CRFEdit;
